import { Suspense as ReactSuspense, SuspenseProps } from 'react';
// import { Spin } from 'antd';
import Loader from 'component/Loader'

export function Suspense(props: Partial<SuspenseProps>) {
  return <ReactSuspense fallback={<Loader />} {...props} />;
}

export default Suspense;
